import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { NavigationComponent } from '../component/navigation/navigation.component';
import { HeaderComponent } from '../component/header/header.component';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Subscription, filter } from 'rxjs';
import { DragScrollDirective } from '../../core/directives/drag-scroll.directive';
import { SoftphoneWidgetComponent } from '../voip/softphone-widget/softphone-widget.component';

@Component({
  selector: 'app-main',
  standalone: true,
  imports: [
    NavigationComponent,
    HeaderComponent,
    RouterOutlet,
    TranslateModule,
    ReactiveFormsModule,
    CommonModule,
    DragScrollDirective,
    SoftphoneWidgetComponent,
  ],
  templateUrl: './main.component.html',
  styleUrl: './main.component.css',
})
export class MainComponent implements OnInit, OnDestroy {

  isCollapsed = false;
  isMobile = false;
  drawerOpen = false;
  showSoftphone = false;

  private bpSub!: Subscription;
  private routerSub!: Subscription;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.bpSub = this.breakpointObserver
      .observe('(max-width: 992px)')
      .subscribe(result => {
        this.isMobile = result.matches;
        if (this.isMobile) {
          this.drawerOpen = false;
        }
      });

    this.showSoftphone = this.isSoftphoneRoute(this.router.url);
    this.routerSub = this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(e => {
        this.showSoftphone = this.isSoftphoneRoute(e.urlAfterRedirects);
      });
  }

  ngOnDestroy(): void {
    this.bpSub?.unsubscribe();
    this.routerSub?.unsubscribe();
  }

  toggleNavigation(event: any): void {
    this.isCollapsed = event;
  }

  onToggleSidebar(): void {
    if (this.isMobile) {
      this.drawerOpen = !this.drawerOpen;
    } else {
      this.isCollapsed = !this.isCollapsed;
    }
  }

  private isSoftphoneRoute(url: string): boolean {
    return url.startsWith('/demo/') || url.startsWith('/voip/') || url.startsWith('/mail/') || url.startsWith('/orders/');
  }

  onDrawerClosed(): void {
    this.drawerOpen = false;
  }
}
